import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function OmOsPage() {
  return (
    <div className="bg-slate-50 min-h-screen py-12">
      <SEO
        title="Om os - Nordfyn Marine"
        description="Læs mere om Nordfyn Marine, vores erfaring, honorarer og mæglerrådgivning ved køb og salg af båd."
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
        {/* Header Hero */}
        <div className="bg-[#0B1B2B] text-white p-8 sm:p-12 rounded-2xl shadow-lg relative overflow-hidden">
          <div className="relative z-10 space-y-3">
            <span className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#2BABE3]">
              Bådformidling med tryghed & erfaring
            </span>
            <h1 className="text-3xl sm:text-4xl font-serif font-bold text-white">
              Om os
            </h1>
            <p className="text-slate-300 text-sm max-w-2xl leading-relaxed">
              Nordfyn Marine yder professionel rådgivning og formidling af både for både køber og sælger.
            </p>
          </div>
        </div>

        {/* Scraped Content Section */}
        <div className="bg-white p-6 sm:p-10 rounded-2xl border border-slate-200 shadow-sm space-y-8 text-slate-700 text-sm sm:text-base leading-relaxed">
          {/* Logo / Header Branding */}
          <div className="flex justify-center pb-4 border-b border-slate-100">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=85,format=auto/assets/7090fdb0-7f55-4b6b-b1f9-a2c2b33a9494/nordfyn-marine-logo.png"
              alt="Nordfyn Marine"
              className="h-16 sm:h-20 w-auto object-contain rounded-xl"
            />
          </div>

          {/* Main Question & Answer Highlight Card */}
          <div className="bg-[#071320] text-white p-6 sm:p-8 rounded-2xl border border-slate-800 space-y-4 shadow-md">
            <h2 className="font-serif font-bold text-lg sm:text-xl text-[#2BABE3] leading-snug">
              Når man tager i betragtning, at Nordfyn Marine skal have honorar, ville det så ikke være billigere at købe eller sælge direkte?
            </h2>
            <p className="text-slate-200 text-sm sm:text-base leading-relaxed italic">
              I almindelighed nej, men selvfølgelig ingen regel uden undtagelser, når heldet tilsmiler dig.
            </p>
          </div>

          {/* Points list from scrape */}
          <div className="space-y-6 pt-2">
            <div className="p-5 bg-slate-50 rounded-2xl border border-slate-200 space-y-2">
              <p className="text-slate-800 font-medium">
                Nordfyn Marine har up-to-date priser på alle både. Dette sikrer køberen at han får den bedste båd for sine penge.
              </p>
            </div>

            <div className="p-5 bg-slate-50 rounded-2xl border border-slate-200 space-y-2">
              <p className="text-slate-800 font-medium">
                At købe gennem Nordfyn Marine giver langt bredere valgmuligheder og indsigt i det rigtige prisniveau.
              </p>
            </div>

            <div className="p-5 bg-slate-50 rounded-2xl border border-slate-200 space-y-2">
              <p className="text-slate-800 font-medium">
                Nordfyn Marine har flere kundeemner, hvilket som regel betyder et hurtigere salg.
              </p>
            </div>

            <div className="p-5 bg-[#2BABE3]/10 border border-[#2BABE3]/30 rounded-2xl space-y-3">
              <p className="text-slate-900 font-medium text-base sm:text-lg">
                Man kan næsten sige. at Nordfyn Marine's vigtigste rolle er at nå frem til den mest fair pris mellem køber og sælger, som repræsentant for begge sider.
              </p>
              <p className="text-slate-800 font-medium">
                Vi fuldbyrder handlen på fair måde for begge parter.
              </p>
            </div>

            <div className="p-5 bg-slate-50 rounded-2xl border border-slate-200 space-y-2">
              <p className="text-slate-800 font-medium">
                Hvad enten du er køber eller sælger betaler det sig som regel at handle gennem Nordfyn Marine.
              </p>
            </div>

            {/* Extra tasks box */}
            <div className="p-6 bg-slate-900 text-slate-100 rounded-2xl border border-slate-800 space-y-3 shadow-sm">
              <div className="flex items-center gap-3 text-[#2BABE3] font-bold text-base">
                <i className="fa-solid fa-shield-halved text-xl" />
                <span>Nordfyn Marine som vagthund</span>
              </div>
              <p className="text-sm leading-relaxed text-slate-300">
                Ud over det at sørge for at handelen går ordentlig igennem, har Nordfyn Marine mange andre opgaver, f.eks. skal vi checke inventarlisten, så den er intakt, sørge for at overtagelsen sker til den fastsatte dag, samt at lån bliver indfriet - med andre ord: agere vagthund, indtil båden sluttelig er enten købt eller solgt.
              </p>
            </div>
          </div>

          {/* Action Footer */}
          <div className="pt-6 border-t border-slate-100 flex flex-col sm:flex-row gap-4 items-center justify-between">
            <div>
              <p className="font-serif font-bold text-slate-900 text-base">
                Nordfyn Marine
              </p>
              <p className="text-xs text-slate-500">
                Kontakt os for en uforpligtende snak om køb eller salg af båd.
              </p>
            </div>

            <Link
              to="/kontakt"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#0B1B2B] hover:bg-[#122B42] text-white px-6 py-3 rounded-xl text-xs font-bold transition-all shadow-md"
            >
              <span>Kontakt os i dag</span>
              <i className="fa-solid fa-arrow-right text-[10px]" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
